import axios from 'axios';
import ConfigConnection from '../config/config.service';
export default class ReportService{
  // API Instance
  configConnection: any = new ConfigConnection();

  private envTKN = this.configConnection.apiKey

  get(){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}user`, config);
  }

  create(report){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`
      }
    };
    return axios.post(`${_.configConnection.apiInstance}test/${user_id}/report`, report, config);
  }

  edit(user, user_id){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`
      }
    };
    return axios.put(`${_.configConnection.apiInstance}user/${user_id}`, user, config);
  }

  getById(user_id){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}candidate/${user_id}/report`, config);
  }

  delete_user(user_id){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`
      }
    };
    return axios.delete(`${_.configConnection.apiInstance}user/${user_id}`, config);
  }

  getCompanies(company_id){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}company/${company_id}`, config);
  }

  assingCompanies(user_id, company_id){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`
      }
    };
    return axios.post(`${_.configConnection.apiInstance}user/${user_id}/company`, {company_id: company_id}, config);
  }

  getInactive(){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}user/inactive`, config);
  }

  active_user(user_id, reactivate){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}user/${user_id}/reactivate`, config);
  }

  getProfileReport(userSurveyId, profileId){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`
      }
    };
    console.log(profileId);
    return axios.get(`${_.configConnection.apiInstance}candidate/${userSurveyId}/report`, config);
  }


  getSingleReport(userId) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`
      }
    };

    return axios.post(`${_.configConnection.apiInstance}candidate/${userId}/report`, config);
  }
}
